import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  &:not(:last-child) {
    margin-bottom: ${themeGet('spacing.xl')};
  }
`;
